import {
  Component,
  ChangeDetectionStrategy,
  inject,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  MatProgressSpinnerModule,
  ProgressSpinnerMode,
} from '@angular/material/progress-spinner';
import { SpinnerService } from './services/spinner-service/spinner.service';
import { AuthService } from './services/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { CONSTANTS_DETAILS } from './shared/models/constants';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MatProgressSpinnerModule],
  templateUrl: './app.component.html',
  providers: [AuthService],
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
  public spinnerService = inject(SpinnerService);
  public spinnerMode: ProgressSpinnerMode = 'indeterminate';
  constructor(
    private _translate: TranslateService,
    private _authService: AuthService,
    public _spinnerService: SpinnerService,
  ) {
    // Set the default language for the application
    this._translate.setDefaultLang(CONSTANTS_DETAILS.APP_DEAULT_LANGUAGE);
    this._translate.use(CONSTANTS_DETAILS.APP_DEAULT_LANGUAGE);
  }
  ngOnInit() {
    this._authService.authInitiator();
  }
  ngOnDestroy() {
    this._authService._destroying$.next();
    this._authService._destroying$.complete();
  }
}
